import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const deactivateDevice = createAsyncThunk(
  "devices/deactivate",
  async (deviceId) => {
    const response = await axiosHttp.put(`attendance/devices/deactivate-device/${deviceId}`);
    return response.data;
  }
);

const deactivateDeviceSlice = createSlice({
  name: "deactivateDevice",
  initialState: {
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deactivateDevice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deactivateDevice.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deactivateDevice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default deactivateDeviceSlice.reducer;